import { render, staticRenderFns } from "./superUpClass.vue?vue&type=template&id=3abc36a0&scoped=true&"
import script from "./superUpClass.vue?vue&type=script&lang=ts&"
export * from "./superUpClass.vue?vue&type=script&lang=ts&"
import style0 from "./superUpClass.vue?vue&type=style&index=0&id=3abc36a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abc36a0",
  null
  
)

export default component.exports